// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".redirect__link[data-v-8b587560]{width:100%;display:flex;align-items:center;justify-content:center;border-radius:16px!important;font-weight:600;font-size:16px;line-height:22px;text-decoration:none}", ""]);
// Exports
module.exports = exports;
